module.exports = __webpack_public_path__ + "static/media/Matlab.cf286322.png";